import styles from './styles.module.scss';

const Modal = (props) => {

    const closeModal = () =>{
        props.click();
    }
    
    return (
        <div className={`${styles.modal}`}>
     
        
            {/* <div className={`${styles.modalArea}`}></div>   */}
            <div onClick={closeModal} className={`${styles.blackoutModal}`}></div>
                   <div onClick={closeModal} className={`${styles.closeModal}`}>x</div>
                          {props.children}
        </div>
    );
}


export default Modal;